import { render, staticRenderFns } from "./Project5.vue?vue&type=template&id=0310fe33&scoped=true&"
import script from "./Project5.vue?vue&type=script&lang=js&"
export * from "./Project5.vue?vue&type=script&lang=js&"
import style0 from "./Project5.vue?vue&type=style&index=0&id=0310fe33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0310fe33",
  null
  
)

export default component.exports